<template>
    <div>
        <br>
        <div class="hero"><h1 class="title has-text-centered">User Profile: {{ username }}</h1></div>
        <section class="section">
            <div class="container">
                <h1 class="title">Password Change</h1>
                <a :href="urls.password_change" class="href">Click here to change your password.</a>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <hr class="hr">
                <div class="hero"><h1 class="title">Two Factor Authentication</h1></div>
                <br>
                <div class="tile is-ancestor is-vertical">
                    <div class="tile is-parent">
                        <div class="tile is-child">
                                <register-phone class="is-not-super-wide"></register-phone>
                        </div>
                        <div class="tile is-child">
                            <register-totp-app class="is-not-super-wide" :username="username" :issuer="siteName">
                            </register-totp-app>
                        </div>
                        <div class="tile is-child">
                            <show-devices class="is-not-super-wide"></show-devices>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ShowDevices from "../components/two_factor/ShowDevices";
    import RegisterPhone from "../components/two_factor/RegisterPhone";
    import RegisterTotpApp from "../components/two_factor/RegisterTotpApp";
    import urls from '../urls';

    export default {
        name: "ProfilePage",
        components: {RegisterTotpApp, RegisterPhone, ShowDevices},
        computed: {
            ...mapState('user', [
                'username',
            ]),
            ...mapState([
                'siteName',
            ]),
        },
        mixins: [urls],
        mounted: function () {
            this.$store.dispatch('user/getTwoFactorDevices');
        },
    }
</script>

<style scoped>

</style>